import SelectEntityCommand from './select-entity';
import InsertBlocksCommand from './insert-blocks';
import Command from './command';
import CommandResult from './command-result';
export default Command.extend({
  processZeroWidth() {
    return this._insertAtMarker();
  },
  processSingleBlock() {
    return this._insertAtMarker();
  },
  processMultiBlock() {
    return this._insertAtMarker();
  },
  _insertAtMarker() {
    this._storeBeforeState();
    let markerWasFound = this._doSelectEntity();
    if (!markerWasFound) {
      return CommandResult.create();
    }
    this._doInsert();
    this._storeAfterState();
    this._updateSelectionAfterPaste();
    return CommandResult.create();
  },
  _storeBeforeState() {
    this.setProperties({
      firstBlockWasEmptyBefore: this.get('firstSelectedBlock.isEmpty'),
      selectionBefore: this.get('selection').getSelectionHash(),
      blockLengthBefore: this.get('selection.blockList.length'),
      itemLengthBefore: this.get('firstSelectedBlock.blockList.length')
    });
  },
  _storeAfterState() {
    this.setProperties({
      selectionAfter: this.get('selection').getSelectionHash(),
      blockLengthAfter: this.get('selection.blockList.length'),
      itemLengthAfter: this.get('firstSelectedBlock.blockList.length')
    });
  },
  _doSelectEntity() {
    let selectionResult = SelectEntityCommand.create({
      blockList: this.get('blockList'),
      selection: this.get('selection'),
      config: this.get('config'),
      options: {
        id: this.get('options.markerId')
      }
    }).run();
    this.set('replacedSelection', this.get('selection').getSelectionHash());
    return selectionResult.get('foundEntity');
  },
  _doInsert() {
    let insertResult = InsertBlocksCommand.create({
      blockList: this.get('blockList'),
      selection: this.get('selection'),
      config: this.get('config'),
      options: this.get('options')
    }).run();
    this.set('insertedBlocks', insertResult.get('insertedBlocks'));
  },
  _updateSelectionAfterPaste() {
    if (this._insertReplacedTextInFirstSelectedBlock()) {
      return;
    }
    if (this._wasToTheLeft()) {
      this._setSelectionToHash(this.get('selectionBefore'));
      return;
    }
    if (this._wasToTheRightInTheSameBlockAndItem() && this._blockCountHasNotChanged() && this._itemCountHasNotChanged()) {
      this._moveRightByPastedTextLength();
      return;
    }
    if (this._wasToTheRightInTheSameBlock() && this._blockCountHasNotChanged()) {
      this._moveRightByPastedItemLength();
      return;
    }
    if (this._wasToTheRightInTheSameBlock()) {
      this._moveRightForPasteSplit();
      return;
    }
    if (this._wasToTheRightInDifferentBlock()) {
      this._moveRightByPastedBlockLength();
      return;
    }
  },
  _insertReplacedTextInFirstSelectedBlock() {
    // This code mirrors some of the code in commands/insert-blocks._insertBlocks
    // The intention is to undersatnd if we replaced the first block with a non paragraph
    // text item. This helps to figure out how to place the cursor inside the inserted block

    if (!this.get('firstBlockWasEmptyBefore')) {
      return false;
    }
    if (this.get('insertedBlocks.length') > 1) {
      return true;
    }
    return this.get('insertedBlocks.firstObject.type') !== 'paragraph' && this.get('insertedBlocks.firstObject.text.length') > 0;
  },
  _wasToTheLeft() {
    let before = this.get('selectionBefore');
    let replacedSelection = this.get('replacedSelection');
    return before.startBlockIndex < replacedSelection.startBlockIndex || before.startBlockIndex === replacedSelection.startBlockIndex && before.startItemIndex < replacedSelection.startItemIndex || before.startBlockIndex === replacedSelection.startBlockIndex && before.startItemIndex === replacedSelection.startItemIndex && before.startPositionIndex < replacedSelection.startPositionIndex;
  },
  _wasToTheRightInTheSameBlock() {
    let before = this.get('selectionBefore');
    let replacedSelection = this.get('replacedSelection');
    return before.startBlockIndex === replacedSelection.startBlockIndex;
  },
  _wasToTheRightInTheSameBlockAndItem() {
    let before = this.get('selectionBefore');
    let replacedSelection = this.get('replacedSelection');
    return before.startBlockIndex === replacedSelection.startBlockIndex && before.startItemIndex === replacedSelection.startItemIndex;
  },
  _wasToTheRightInDifferentBlock() {
    let before = this.get('selectionBefore');
    let replacedSelection = this.get('replacedSelection');
    return before.startBlockIndex > replacedSelection.startBlockIndex;
  },
  _setSelectionToHash(hash) {
    this.get('selection').setProperties(hash);
  },
  _blockCountHasNotChanged() {
    return this.get('blockLengthBefore') === this.get('blockLengthAfter');
  },
  _itemCountHasNotChanged() {
    return this.get('itemLengthBefore') === this.get('itemLengthAfter');
  },
  _moveRightByPastedTextLength() {
    let selection = this.get('selectionBefore');
    let firstPastedBlockLength = this.get('insertedBlocks.firstObject.text.length');
    selection.startPositionIndex += firstPastedBlockLength - 1;
    selection.endPositionIndex += firstPastedBlockLength - 1;
    this._setSelectionToHash(selection);
  },
  _moveRightByPastedItemLength() {
    let selection = this.get('selectionBefore');
    let addedItems = this.get('itemLengthAfter') - this.get('itemLengthBefore');
    selection.startItemIndex += addedItems;
    selection.endItemIndex += addedItems;
    this._setSelectionToHash(selection);
  },
  _moveRightForPasteSplit() {
    let selection = this.get('selectionBefore');
    let addedBlocks = this.get('blockLengthAfter') - this.get('blockLengthBefore');
    let replacedEnd = this.get('replacedSelection.endPositionIndex');
    selection.startPositionIndex -= replacedEnd;
    selection.endPositionIndex -= replacedEnd;
    selection.startBlockIndex += addedBlocks;
    selection.endBlockIndex += addedBlocks;
    this._setSelectionToHash(selection);
  },
  _moveRightByPastedBlockLength() {
    let selection = this.get('selectionBefore');
    let addedBlocks = this.get('blockLengthAfter') - this.get('blockLengthBefore');
    selection.startBlockIndex += addedBlocks;
    selection.endBlockIndex += addedBlocks;
    this._setSelectionToHash(selection);
  }
});